<template>
  <section ref="section" class="-visibility-auto dual-tile">
    <Observer name="dual-enter" @enter="enter">
      <div class="container-fluid">
        <div class="row">
          <router-link class="tile col-12 col-md" v-for="tileItem in items" :key="tileItem.title" :to="localizedUrl + tileItem.link">
            <div class="image-container" :class="[ item && item.animated ? '-animated': '']">
              <LazyPicture :item="tileItem" preserve-ratio="true" />
            </div>
            <h2 :class="['title link-light h4', tileItem.textColor === 'white' ? '-white' : '']" v-if="tileItem.title" v-text="tileItem.title"></h2>
          </router-link>
        </div>
      </div>
    </Observer>
  </section>
</template>

<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { ReadyHook } from 'vue-asyncready'
import LazyPicture from '../utils/LazyPicture.vue';

export default {
  mixins: [ReadyHook],
  name: 'HRDualTile',
  props: ['item', 'items', 'pagePosition', 'siblings-components'],
  components: {
    LazyPicture
  },
  data() {
    return {
      appeared: false
    }
  },
  computed: {
    localizedUrl() {
      const { url } = currentStoreView()
      return url || ''
    }
  },
  methods: {
    enter() {
      if (!this.appeared) {
        this.$refs.section.classList.remove('-visibility-auto')
        this.appeared = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

section {
  position: relative;
  margin: 8rem 0;

  @include bp(max md) {
    margin: 4rem 0;
  }

  .container-fluid {
    padding-inline: 6rem;

    @include bp(max md) {
      padding-inline: 0;
    }

    .row {
      margin-inline: 0;
      gap: 1rem
    }

    .tile {
      display: flex;
      flex-direction: column;
      padding-inline: 0;

      .image-container {
        overflow: hidden;
        aspect-ratio: 4/5;

        .lazy-picture {
          height: 100%;

          /deep/ img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: all 2s cubic-bezier(0.075, 0.82, 0.165, 1);
          }
        }

        &:hover.-animated {
          .lazy-picture /deep/ img{
            transform: scale(1.1);
          }
        }
      }

      .title {
        text-align: center;

        &.-white {
          color: var(--zenith-white);
        }

        &.link-light {
          color: var(--zenith-theme-primary);
          margin: 2rem auto 0 auto;
          width: max-content;

          &::before {
            background-color: var(--zenith-theme-primary);
          }
        }
      }
    }
  }
}
</style>
